import { useAppDispatch, useAppSelector } from "../../hooks"

import { LoadingStatus, selectLoadingStatusState, selectQrScanState } from "./qrScanSlice"
import { Loading } from "../../components/loading/Loading";
import { TopLine } from "../../components/top-line/TopLine";
import './qr-scan.scss';
import useSmartHistory from "../../metrica/metrica";
import { Keyboard } from "../keyboard/Keyboard";
import { onBackspace, onKey, onChangeFocus } from "./qrScanSlice";
import { Numboard } from "../numboard/numboard";
import { searchOrder } from '../../network/actions';
export function QrScan() {
    const qrScanLoadingStatus = useAppSelector(selectLoadingStatusState);
    const qrScan = useAppSelector(selectQrScanState)
    const dispatch = useAppDispatch()
    const navigate = useSmartHistory()
    const qrScanData = useAppSelector(selectQrScanState)
    if (qrScan == null) {
        return <Loading />
    }
   
    return (<>
        <TopLine onClickBack={() => { navigate.goBack() }} sectionStyle='left' sectionHeading='' sectionType='icon' sectionIconName='back-button.svg' >
            <div>
                Отсканируйте <span className="primaryText">QR-код</span>
            </div>
        </TopLine>

        <div className="qrScanImage above-buttons-block">
            <div className="col">
                <video autoPlay loop muted height="" className="finish-video qr-video">
                    <source className="footer-video_content" src="/assets/videos/videoqr.mp4" type='video/mp4' />
                </video>


            </div>
            <div className="col">
                {/* <div className="primary">
                    У меня нет<br/>
                    QR-кода заказа
                </div> */}
                <div className="qr-inputs qr-keyboard">
                    <div className="order-input_line">
                        <div className="order-input_wrapper" onClick={() => dispatch(onChangeFocus('orderId'))}>
                            <input value={qrScanData.orderId}
                                type="text"
                                onChange={() => { }}
                                className={`order-input ${qrScanData.focusInputKey == 'orderId' ? 'focused' : ''}`}
                                placeholder="Order ID" />
                        </div>
                    </div>
                    <div className="order-input_line">
                        <div className="order-input_wrapper" onClick={() => dispatch(onChangeFocus('accessCode'))}>
                            <input value={qrScanData.accessCode}
                                type="text"
                                onChange={() => { }}
                                className={`order-input ${qrScanData.focusInputKey == 'accessCode' ? 'focused' : ''}`}
                                placeholder="Access Code" />
                        </div>
                    </div>
                  
                </div>
                <div className="input-keyboard-column">
                    <div className="numboard_wrapper">
                        <Numboard
                            onBackspace={() => { dispatch(onBackspace()); }}
                            onKey={(a) => { dispatch(onKey(a)); }}
                        />
                    </div>
                </div>
                <div>
                    <button className={`main-button yellow qr-search-button`}
                    onClick={() => {
                        dispatch(searchOrder({order_id:+qrScanData.orderId,access_code:qrScanData.accessCode}))
                    }}
                    >Найти</button>
                </div>
            </div>

        </div>
        <div className="defects_buttons">
            <button onClick={() => { navigate.push('/'); }} className="main-button black back">Назад</button>
            <button className={`main-button yellow next invisible`} >Далее</button>
        </div>
    </>)

}
